import { useMemo } from 'react'
import { useSelector } from 'react-redux'

const useConfiguration = () => {
    const pscState = useSelector(state => state.pscState.value)
    const config = pscState.config || {}

    const featureSharePoint = useMemo(() => config.feature_sharepoint_enabled === "1", [config.feature_sharepoint_enabled])
    const featureTraceability = useMemo(() => config.feature_traceability_enabled === "1", [config.feature_traceability_enabled])
    
    const documentsInitialIssue = useMemo(() => {
        return config.documents_initial_issue || "01"
    }, [config.documents_initial_issue])

    const siteName = useMemo(() => {
        return config.site_name || "GNC"
    }, [config.site_name])
    
    return {
        config,
        featureSharePoint,
        featureTraceability,
        documentsInitialIssue,
        siteName,
    }
}

export default useConfiguration
